import { apiRequest } from "./request";
import { IUserJob } from "@/types";
import { IJobListing } from "@/types/job";

interface SearchJobsResponse {
    jobs: IJobListing[];
    total: number;
    page: number;
    limit: number;
}

const searchJobs = ({
    term,
    location,
    remote,
    page,
    limit,
}: {
    term: string;
    location: string;
    remote: boolean;
    page: number;
    limit: number;
}) => {
    return apiRequest<SearchJobsResponse>(
        `/job/search?term=${term}&location=${location}&remote=${remote}&page=${page}&limit=${limit}`,
        "GET",
    );
};

const saveJob = (data: Partial<IJobListing>) => {
    const jobDetails = {
        jobTitle: data.title,
        jobDescription:
            data.description_text?.trim() ||
            data.description_html?.trim() ||
            "",
        companyName: data.organization,
        location: data.locations_derived?.join(", ") || "",
        jobPostingUrl: data.url,
        jobBoardId: data.id,
    };
    return apiRequest<IUserJob>("/job/save", "POST", jobDetails);
};

export default {
    saveJob,
    searchJobs,
};
